
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const DeletedMessage: React.FC = () => {
  return (
    <Card className="mb-4 opacity-50">
      <CardContent className="pt-4 italic text-muted-foreground">
        Dit bericht is verwijderd
      </CardContent>
    </Card>
  );
};

export default DeletedMessage;
